export default __webpack_public_path__ + "static/media/lot.a8410e53.png";